import React from 'react';
import Helpers from './Helpers.js'
import './Bars.css';


class Bars extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
		}
	}

	getPercent(total,part) {
		let output = Math.floor(part/total*100*100)/100;
		return (output)
	}

	render() {
		if(this.props.barMode==="polls_electors") {
			return(
				<div className={'bigBars '+this.props.barMode}>
					<div className='totalBarTotalBox'>Totals
					<div className='totalBarBarsBox'>
							<div className='bar total D-solid' style = {{width: Helpers.getPercent(this.props.totals.all_electors,this.props.polls['D-solid'].electors*1)+"%" }} title={this.props.polls['D-solid'].electors} ></div>
							<div className='bar total D-likely' style = {{width: Helpers.getPercent(this.props.totals.all_electors,this.props.polls['D-likely'].electors*1)+"%" }} ></div>
							<div className='bar total D-leans' style = {{width: Helpers.getPercent(this.props.totals.all_electors,this.props.polls['D-leans'].electors*1)+"%" }} ></div>
							<div className='bar total Tossup' style = {{width: Helpers.getPercent(this.props.totals.all_electors,this.props.polls['Tossup'].electors*1)+"%" }} ></div>
							<div className='bar total R-leans' style = {{width: Helpers.getPercent(this.props.totals.all_electors,this.props.polls['R-leans'].electors*1)+"%" }} ></div>
							<div className='bar total R-likely' style = {{width: Helpers.getPercent(this.props.totals.all_electors,this.props.polls['R-likely'].electors*1)+"%" }} ></div>
							<div className='bar total R-solid' style = {{width: Helpers.getPercent(this.props.totals.all_electors,this.props.polls['R-solid'].electors*1)+"%" }} ></div>
						</div>
						<div className='totalBarHoverBox'>
							<div className='bar-hover total D-solid' style = {{width: Helpers.getPercent(this.props.totals.all_electors,this.props.polls['D-solid'].electors*1)+"%" }} title={this.props.polls['D-solid'].electors} ></div>
							<div className='bar-hover total D-likely' style = {{width: Helpers.getPercent(this.props.totals.all_electors,this.props.polls['D-likely'].electors*1)+"%" }} title={this.props.polls['D-likely'].electors} ></div>
							<div className='bar-hover total D-leans' style = {{width: Helpers.getPercent(this.props.totals.all_electors,this.props.polls['D-leans'].electors*1)+"%" }} title={this.props.polls['D-leans'].electors} ></div>
							<div className='bar-hover total Tossup' style = {{width: Helpers.getPercent(this.props.totals.all_electors,this.props.polls['Tossup'].electors*1)+"%" }} title={this.props.polls['Tossup'].electors} ></div>
							<div className='bar-hover total R-leans' style = {{width: Helpers.getPercent(this.props.totals.all_electors,this.props.polls['R-leans'].electors*1)+"%" }} title={this.props.polls['R-leans'].electors} ></div>
							<div className='bar-hover total R-likely' style = {{width: Helpers.getPercent(this.props.totals.all_electors,this.props.polls['R-likely'].electors*1)+"%" }} title={this.props.polls['R-likely'].electors} ></div>
							<div className='bar-hover total R-solid' style = {{width: Helpers.getPercent(this.props.totals.all_electors,this.props.polls['R-solid'].electors*1)+"%" }} title={this.props.polls['R-solid'].electors} ></div>
						</div>
						<div className='totalBarOverlaysBox'>
							<div className='overlay total D' >
								<span className='absolute'><b>{this.props.polls['D-solid'].electors+this.props.polls['D-likely'].electors+this.props.polls['D-leans'].electors}</b></span>
							</div>
							{/* <div className='overlay total T' >
								<span className='absolute'><b>{this.props.polls['Tossup'].electors}</b></span>
							</div> */}
							<div className='overlay total R' >
								<span className='absolute'><b>{this.props.polls['R-solid'].electors+this.props.polls['R-likely'].electors+this.props.polls['R-leans'].electors}</b></span>
							</div>
						</div>
					</div>	
				</div>
			)            
		}	
		else if(this.props.barMode==="polls_votes") {
			return true
		}
		else if(this.props.barMode==="electors") {
			return(
				<div className={'bigBars '+this.props.barMode}>
					<div className='totalBarTotalBox'>Totals
						<div className='totalBarBarsBox'>
							<div className='bar total D' style = {{width: Helpers.getPercent(this.props.totals.all_electors,this.props.candidates.o[this.props.parties.o["Democratic Party"].ticket.president][this.props.barMode])+"%" }} > </div>
							<div className='bar total others' style = {{width: Helpers.getPercent(this.props.totals.all_electors,(this.props.totals.attributed.others[this.props.barMode]))+"%" }} ></div>
							<div className='bar total unassigned' style = {{width: Helpers.getPercent(this.props.totals.all_electors,(this.props.totals.all_electors-this.props.totals.attributed[this.props.barMode]))+"%" }} ></div>
							<div className='bar total R' style = {{width: Helpers.getPercent(this.props.totals.all_electors,this.props.candidates.o[this.props.parties.o["Republican Party"].ticket.president][this.props.barMode])+"%" }} ></div>
						</div>
						<div className='totalBarOverlaysBox'>
							<div className='overlay total D' >
								<span className='percent'>{Helpers.tsnds(this.props.candidates.o[this.props.parties.o["Democratic Party"].ticket.president]["percent"]) } %&nbsp;&nbsp;&nbsp;</span>
								<span className='absolute'><span className='bracket'>(</span>{Helpers.tsnds(this.props.candidates.o[this.props.parties.o["Democratic Party"].ticket.president][this.props.barMode]) }<span className='bracket'>)</span></span>
							</div>
							<div className='overlay total R' >
								<span className='absolute'> <span className='bracket'>(</span>{Helpers.tsnds(this.props.candidates.o[this.props.parties.o["Republican Party"].ticket.president][this.props.barMode]) }<span className='bracket'>)</span></span>
								<span className='percent'>&nbsp;&nbsp;&nbsp;{Helpers.tsnds(this.props.candidates.o[this.props.parties.o["Republican Party"].ticket.president]["percent"]) } %</span>
							</div>
						</div>
					</div>	
				</div>
			)            
		}
		else if(this.props.barMode==="votes") {
			return(
				<div className={'bigBars '+this.props.barMode}>
					<div className='totalBarTotalBox'>Totals
						<div className='totalBarBarsBox'>
							<div className='bar total D' style = {{width: this.props.candidates.o[this.props.parties.o["Democratic Party"].ticket.president].percent+"%" }} > </div>
							<div className='bar total others' style = {{width: this.props.totals.attributed.others.percent+"%" }} ></div>
							<div className='bar total R' style = {{width:this.props.candidates.o[this.props.parties.o["Republican Party"].ticket.president].percent+"%" }} ></div>
						</div>
						<div className='totalBarOverlaysBox'>
							<div className='overlay total D' >
								<span className='percent'>{Helpers.tsnds(this.props.candidates.o[this.props.parties.o["Democratic Party"].ticket.president]["percent"]) } %&nbsp;&nbsp;&nbsp;</span>
								<span className='absolute'><span className='bracket'>(</span>{Helpers.tsnds(this.props.candidates.o[this.props.parties.o["Democratic Party"].ticket.president][this.props.barMode]) }<span className='bracket'>)</span></span>
							</div>
							<div className='overlay total R' >
								<span className='absolute'> <span className='bracket'>(</span>{Helpers.tsnds(this.props.candidates.o[this.props.parties.o["Republican Party"].ticket.president][this.props.barMode]) }<span className='bracket'>)</span></span>
								<span className='percent'>&nbsp;&nbsp;&nbsp;{Helpers.tsnds(this.props.candidates.o[this.props.parties.o["Republican Party"].ticket.president]["percent"]) } %</span>
							</div>
						</div>
					</div>	
				</div>
			)         
		}
		else {
			return true
		}



	}
}

export default Bars
